import React from 'react'
import { Link } from "react-router-dom";


const HomeBlog = () => {
    return (
        <>

            <div className="blog-area py-120" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <span className="site-title-tagline"><i className="fas fa-solar-panel" /> Our Blog</span>
                                <h2 className="site-title">Our Latest News &amp; <span>Blog</span></h2>
                                <div className="heading-divider" />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="blog-item-img">
                                    <img src="assets/img/blog/01.jpg" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>20 </strong>
                                    <span> February</span>
                                </div>
                                <div className="blog-item-info">
                                    
                                    <h4 className="blog-title">
                                        <Link to="/blog-details">Slash Your Electricity Bill: How Solar Power Pays for Itself</Link>
                                    </h4>
                                    <p style={{textAlign:"justify"}}>
                                        This summer, the temperatures are so high that you can't get by without turning on the AC or fan, leading to hefty electricity bills that can be a real shock for your pocket. 
                                    </p>
                                    <Link className="theme-btn" to="/blog-details">Read More<i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="blog-item-img">
                                    <img src="assets/yog/How to Choose.webp" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>28 </strong>
                                    <span> February</span>
                                </div>
                                <div className="blog-item-info">
                                    <h4 className="blog-title">
                                        <Link to="/blog-details">How to Choose the Right Solar Solution for Your House Size</Link>
                                    </h4>
                                    <p style={{textAlign:"justify"}}>
                                        Thinking about switching to solar power? Yogesh Solar Energy Is a Perfect Solution for saving money on electricity bills and helping the environment.
                                    </p>
                                    <Link className="theme-btn" to="/blog-details">Read More<i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="blog-item-img">
                                    <img src="assets/img/blog/03.jpg" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>18</strong>
                                    <span> March</span>
                                </div>
                                <div className="blog-item-info">
                                    <h4 className="blog-title">
                                        <Link to="/blog-details">How Are Solar Energy Policies Driving Market Growth?</Link>
                                    </h4>
                                    <p style={{textAlign:"justify"}}>
                                       The global energy landscape is undergoing a significant transformation, driven by the urgent need to address climate change and secure sustainable
                                    </p>
                                    <Link className="theme-btn" to="/blog-details">Read More<i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>



        </>
    )
}

export default HomeBlog